import { render, staticRenderFns } from "./PrintingRolls.vue?vue&type=template&id=c7680d80"
import script from "./PrintingRolls.vue?vue&type=script&lang=js"
export * from "./PrintingRolls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports